import React from 'react';

const FaqBlockRenderer = ({ blocks }) => {
  if (!blocks || !Array.isArray(blocks)) {
    return null;
  }

  const renderListItems = (items) => {
    return items.map((item, i) => {
      if (typeof item === 'string') {
        return (
          <li
            key={i}
            dangerouslySetInnerHTML={{ __html: item }}
            className="text-gray-600 dark:text-[var(--text-secondary)]"
          />
        );
      } else {
        return (
          <li key={i} className="text-gray-600 dark:text-[var(--text-secondary)]">
            <span dangerouslySetInnerHTML={{ __html: item.content || '' }} />
            {item.items && item.items.length > 0 && (
              <ul className="list-disc list-inside ml-5 mt-1 space-y-1">
                {renderListItems(item.items)}
              </ul>
            )}
          </li>
        );
      }
    });
  };

  return (
    <div className="faq-rich-text space-y-3 text-sm sm:text-[15px] leading-relaxed">
      {blocks.map((block, index) => {
        switch (block.type) {
          case 'paragraph':
            return (
              <p
                key={index}
                dangerouslySetInnerHTML={{ __html: block.data.text }}
                className="text-gray-600 dark:text-[var(--text-secondary)] leading-relaxed [&_strong]:font-semibold [&_strong]:text-gray-800 dark:[&_strong]:text-[var(--text-primary)] [&_em]:italic [&_u]:underline [&_a]:text-orange-500 [&_a]:underline"
              />
            );

          case 'header':
            const level = block.data.level || 3;
            const sizes = {
              1: 'text-xl font-bold',
              2: 'text-lg font-bold',
              3: 'text-base font-bold',
              4: 'text-sm font-bold',
              5: 'text-sm font-semibold',
              6: 'text-xs font-semibold uppercase tracking-wide',
            };
            const Tag = `h${level}`;
            return (
              <Tag
                key={index}
                dangerouslySetInnerHTML={{ __html: block.data.text }}
                className={`${sizes[level] || 'text-base font-bold'} text-gray-800 dark:text-[var(--text-primary)] mt-4 mb-1`}
              />
            );

          case 'list':
            const ListTag = block.data.style === 'ordered' ? 'ol' : 'ul';
            const listClass =
              block.data.style === 'ordered'
                ? 'list-decimal list-inside space-y-1.5 ml-1'
                : 'list-disc list-inside space-y-1.5 ml-1';

            return (
              <ListTag key={index} className={listClass}>
                {renderListItems(block.data.items)}
              </ListTag>
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default FaqBlockRenderer;
